import { useQuery } from '@tanstack/react-query';
import { MsApiEndPoints } from '@wolfejs/ms-api-js/src';
import { FundsBank } from '@wolfejs/ms-api-js/src/types/fundsBank';
import { useMsClient } from '@wolfejs/ms-api-react/src/contexts';
import type { ReactQueryOptions } from '@wolfejs/ms-api-react/src/types';
import { getFundsBank } from './api';

/**
 * This hook is used to get the user's funds bank
 */
export function usePGCorpFundsBank(options?: ReactQueryOptions<FundsBank>) {
  const { client } = useMsClient();

  const key = MsApiEndPoints.myaccount.funds();

  return useQuery({
    ...options,
    // @ts-ignore
    queryKey: [key],
    queryFn: () => getFundsBank(client),
  });
}
